import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule, MatDatepickerModule, MatCheckboxModule, MatTableModule, MatTabsModule, MatDividerModule, MatListModule, MatChipsModule, MatDialogModule, MatMenuModule, MatRippleModule, MatSidenavModule, MatToolbarModule, MatTooltipModule, MatPaginatorModule, MatProgressBarModule, MatNativeDateModule, MatSnackBarModule } from "@angular/material";
import { RouterModule } from "@angular/router";
import { FuseWidgetModule, FuseConfirmDialogModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { NgxDnDModule } from "@swimlane/ngx-dnd";
import { AreaInterativaComponent } from "../content/areainterativa/areainterativa.component";
import { ConsultarConvitesComponent } from "../content/areainterativa/consultarConvites/consultarConvites.component";
import { ConsultarDocumentosComponent } from "../content/areainterativa/consultarDocumentos/consultarDocumentos.component";
import { DocumentosComponent } from "../content/areainterativa/documentos/documentos.component";
import { ModalVisualizarComponent } from "../content/areainterativa/pergunta-resposta/modal-visualizar/modal-visualizar.component";
import { PerguntaRespostaComponent } from "../content/areainterativa/pergunta-resposta/pergunta-resposta.component";
import { UploadDocumentosComponent } from "../content/areainterativa/uploadDocumentos/uploadDocumentos.component";
import { SharedModule } from "../content/shared/shared.module";
import { GestorFinanceiroComponent } from "./GestorFinanceiro.component";




const routes = [
    {
        path: 'gestor-financeiro',
        component: GestorFinanceiroComponent
    },


];

@NgModule({
    declarations: [GestorFinanceiroComponent, ],
    imports: [
        SharedModule,
        CommonModule,
        FuseSharedModule,
        FuseWidgetModule,
        RouterModule.forChild(routes),
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatTableModule,
        MatTabsModule,
        MatDividerModule,
        MatListModule,
        MatChipsModule,
        MatDialogModule,
        MatMenuModule,
        MatRippleModule,
        MatSidenavModule,
        MatToolbarModule,
        MatTooltipModule,
        NgxDnDModule,
        FuseConfirmDialogModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatNativeDateModule,
        MatSnackBarModule,
    
    ],
    exports: [GestorFinanceiroComponent]
})
export class GestorFinanceiroModule { }